import usePrivateAxios from '@/common/api/usePrivateAxios'
import { Mapper } from '@/common/services/mapper'
import { ActualEntryFilterOptionsResponse } from '@/features/maintenanceWorkflow/types/maintenanceWorkflowActualEntryFilter.type'
import { useQuery } from '@tanstack/react-query'

type UseMaintenanceForwardingsActualEntryFilterOptionsProps<T> = {
  mapper?: (data: any) => T
}

export const useMaintenanceForwardingsActualEntryFilterOptions = <T = ActualEntryFilterOptionsResponse>({
  mapper = Mapper.default<T>(),
}: UseMaintenanceForwardingsActualEntryFilterOptionsProps<T> = {}) => {
  const privateAxios = usePrivateAxios()

  return useQuery({
    queryKey: ['maintenanceForwardingsActualEntryFilterOptions'],
    queryFn: () => privateAxios.get('/maintenance/forwardings/possible_actual_entry_filter_options'),
    select: (data: { data: { data: ActualEntryFilterOptionsResponse } }) => mapper(data?.data?.data),
  })
}
